import { Auth } from 'aws-amplify';
import axios from 'axios';
import {
  CRUISE_SETTING_URL,
  CRUISE_API_KEY,
  GET_MWID_AUTHZDB,
  AUTHZDB_BASEURL,
  getInvoiceApiUrl,
  PPA_API_BASEURL,
} from '../../configures/val.js';
import findLocalStorage from './findLocalStorage.js';

async function authCheck () {
  try{
    const user = await Auth.currentAuthenticatedUser();
    const attrRet = await Auth.userAttributes(user);
    const ret = {
      result: 'OK',
      data: attrRet
    }
    return ret;
  } catch (error) {
    console.log('error == authCheck');
    await Auth.signOut();
    const ret = {
      result: 'NG',
      data: error
    }
    return ret;
  }
}

export async function getCruiseSetting (mierukaId) {
  const config = {
    headers: {
      'X-Api-Key': CRUISE_API_KEY,
    }
  };
  try {
    const urlStr = CRUISE_SETTING_URL + mierukaId
    let result = await axios.get(urlStr, config);
    const ret = {
      result: 'OK',
      data: result
    }
    return ret;
  } catch (error) {
    console.log('error == getCruiseSetting');
    const ret = {
      result: 'NG',
      data: error
    }
    return ret;
  }
}

export async function putCruiseSetting (mierukaId, param) {
  const idtoken = findLocalStorage('idToken');
  const accessToken = findLocalStorage('accessToken');
  const config = {
    headers: {
      'x-api-key': CRUISE_API_KEY,
      'idtoken': idtoken,
      'accesstoken': accessToken,
    }
  };
  try {
    const urlStr = CRUISE_SETTING_URL + mierukaId
    let result = await axios.put(urlStr, param, config);
    const ret = {
      result: 'OK',
      data: result
    }
    return ret;
  } catch (error) {
    console.log('error == putCruiseSetting');
    const ret = {
      result: 'NG',
      data: error
    }
    return ret;
  }
}

export async function deleteCruiseSetting (mierukaId) {
  const urlStr = CRUISE_SETTING_URL + mierukaId
  const idtoken = findLocalStorage('idToken');
  const accessToken = findLocalStorage('accessToken');
  const config = {
    headers: {
      'x-api-key': CRUISE_API_KEY,
      'accesstoken': accessToken,
      'idtoken': idtoken,
    }
  };
  try {
    let result = await axios({
      method: 'delete',
      url: urlStr,
      headers: config.headers,
    });
    const ret = {
      result: 'OK',
      data: result
    }
    return ret;
  } catch (error) {
    console.log('error == deleteCruiseSetting');
    const ret = {
      result: 'NG',
      data: error
    }
    return ret;
  }
}
export async function getMierukaIds () {
  const urlStr = GET_MWID_AUTHZDB + 'mierukawebids';
  const token = findLocalStorage('accessToken');
  const config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  };
  try {
    let result = await axios.get(urlStr, config);
    const ret = {
      result: 'OK',
      data: result
    }
    return ret;
  } catch (error) {
    console.log('error == getMierukaIds');
    console.log(error);
    const ret = {
      result: 'NG',
      data: error
    }
    return ret;
  }
}
export async function getCanIAccessToFromAuthzdb (mwid) {
  const urlStr = GET_MWID_AUTHZDB + 'cani/editmieruka/' + mwid;
  const token = findLocalStorage('accessToken');
  const config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  };
  try {
    let result = await axios.get(urlStr, config);
    const ret = {
      result: 'OK',
      data: result
    }
    return ret;
  } catch (error) {
    console.log('error == getCanIAccessToFromAuthzdb');
    console.log(error);
    const ret = {
      result: 'NG',
      data: error
    }
    return ret;
  }
}
export async function getCanIAccessAsSuperFromAuthzdb () {
  const urlStr = GET_MWID_AUTHZDB + 'amisuper';
  const token = findLocalStorage('accessToken');
  const config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  };
  try {
    let result = await axios.get(urlStr, config);
    const ret = {
      result: 'OK',
      data: result
    }
    return ret;
  } catch (error) {
    console.log('error == getCanIAccessAsSuperFromAuthzdb');
    console.log(error);
    const ret = {
      result: 'NG',
      data: error
    }
    return ret;
  }
}
export async function getInvoiceList () {
  const urlStr = getInvoiceApiUrl('billList');
  const token = findLocalStorage('idToken');
  const config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  };
  try {
    let result = await axios.get(urlStr, config);
    const ret = {
      result: 'OK',
      data: result.data
    }
    return ret;
  } catch (error) {
    console.log('error == getInvoiceApiUrl');
    console.log(error);
    const ret = {
      result: 'NG',
      data: error
    }
    return ret;
  }
}
export async function getCanIseeInvoiceList () {
  const urlStr = GET_MWID_AUTHZDB + 'cani/see/invoice_list';
  const token = findLocalStorage('accessToken');
  const config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  };
  try {
    let result = await axios.get(urlStr, config);
    const ret = {
      result: 'OK',
      data: result.data
    }
    return ret;
  } catch (error) {
    console.log('error == getCanIseeInvoicelist');
    console.log(error);
    const ret = {
      result: 'NG',
      data: error
    }
    return ret;
  }
}
export async function getInvoiceReport (fileName) {
  let urlStr = getInvoiceApiUrl('report');
  urlStr += '/' + fileName;
  const token = findLocalStorage('idToken');
  const config = {
    headers: {
      'Content-Type': 'application/pdf',
      'Authorization': 'Bearer ' + token
    },
    responseType: 'blob'
  };
  try {
    let result = await axios.get(urlStr, config);
    const url = window.URL.createObjectURL(new Blob([result.data]));
    const link = document.createElement('a');
    link.href = url;
    const downloadFilename = fileName + '.pdf';
    link.setAttribute('download', downloadFilename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return {result: 'OK'};
  } catch (error) {
    console.log('error == getInvoiceReport');
    console.log(error);
    const ret = {
      result: 'NG',
      data: error
    }
    return ret;
  }
}
// AuthZ ===
// PPA 発電所一覧の products を得るための 事業者ID の列挙を返す
export function getPpaSid() {
  const urlParam = 'belong/ppasupplier';
  return getAuthz(urlParam);
}
function getAuthz(to, params) {
  const url = AUTHZDB_BASEURL + to;
  const authHeader = findLocalStorage('idToken');
  const headers = {
    Authorization: 'Bearer ' + authHeader
  };
  return getApi(url, headers, params);
}

// PPA ===
export function getPpaService(sId) {
  const urlParam = 'service/' + sId;
  return getPpaApi(urlParam);
}
export function getPpaProduct(params) {
  return getPpaApi('products', params);
}
function getPpaApi(to, params) {
  const url = PPA_API_BASEURL + to;
  const authHeader = findLocalStorage('idToken');
  const headers = {
    Authorization: authHeader
  }
  return getApi(url, headers, params);
}

export function postPpaDisplayPattern(params) {
  const url = 'displaypattern/';
  return postPpaApi(url, params);
}
function postPpaApi(to, params) {
  const url = PPA_API_BASEURL + to;
  const authHeader = findLocalStorage('idToken');
  const headers = {
    Authorization: authHeader
  }
  return postApi(url, headers, params);
}

export function putPpaDisplayPatternId(pId, params) {
  const url = 'product/' + pId + '/displaypatternid';
  return putPpaApi(url, params);
}
export function putPpaDisplayPattern(pId, params) {
  const url = 'displaypattern/' + pId
  return putPpaApi(url, params);
}
function putPpaApi(to, params) {
  const url = PPA_API_BASEURL + to;
  const authHeader = findLocalStorage('idToken');
  const headers = {
    Authorization: authHeader
  }
  return putApi(url, headers, params);
}
export function deletePpaDisplayPattern(pId, sId) {
  const url = `displaypattern/${pId}?supplierId=${sId}`;
  return deletePpaApi(url);
}
function deletePpaApi(to, param) {
  const url = PPA_API_BASEURL + to ;
  const authHeader = findLocalStorage('idToken');
  const headers = {
    Authorization: authHeader
  }
  return deleteApi(url, headers);
}


// PPMS ===
// PPMS 発電所管理システムの利用権限を取得する
export async function getCanISeePpms() {
  const urlStr = AUTHZDB_BASEURL + 'cani/see/ppms';
  const token = findLocalStorage('accessToken');
  const config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  };
  try {
    let result = await axios.get(urlStr, config);
    if (result.data.result !== undefined) {
      return result.data.result;
    }
    return false;
  } catch (error) {
    console.log('error == getCanISeePpms');
    console.log(error);
    return false;
  }
}

// Common ===
async function getApi(urlStr, header, params) {
  const config = {};
  if (header) {
    config.headers = header;
  }
  if (params) {
    config.params = params;
  }
  try {
    const res = await axios.get(urlStr, config);
    return {
      result: 'OK',
      data: res.data
    };
  } catch (err) {
    console.log(urlStr + 'GET API err');
    const errs = getErrors(err);
    return {
      result: 'NG',
      data: errs
    };
  }
}
async function postApi(urlStr, header, params) {
  const config = {};
  if (header) {
    config.headers = header;
  }
  try {
    const res = await axios.post(urlStr, params, config);
    return {
      result: 'OK',
      data: res.data
    };
  } catch (err) {
    console.log(urlStr + 'POST API err');
    const errs = getErrors(err);
    return {
      result: 'NG',
      data: errs
    };
  }
}
async function putApi(urlStr, header, params) {
  const config = {};
  if (header) {
    config.headers = header;
  }
  try {
    const res = await axios.put(urlStr, params, config);
    return {
      result: 'OK',
      data: res.data
    };
  } catch (err) {
    console.log(urlStr + 'PUT API err');
    const errs = getErrors(err);
    return {
      result: 'NG',
      data: errs
    };
  }
}
async function deleteApi(urlStr, header) {
  const config = {};
  if (header) {
    config.headers = header;
  }
  try {
    const res = await axios.delete(urlStr, config);
    return {
      result: 'OK',
      data: res.data
    };
  } catch (err) {
    console.log(urlStr + 'DELETE API err');
    const errs = getErrors(err);
    return {
      result: 'NG',
      data: errs
    };
  }
}
function getErrors(catchErr) {
  const resObj = {};
  if (catchErr.response) {
    resObj.data = catchErr.response.data;
    resObj.status = catchErr.response.status;
    resObj.headers = catchErr.response.headers;
  }
  if (catchErr.message) {
    resObj.message = catchErr.message;
  }
  return resObj;
}

export default authCheck;
